import { createContext, useContext } from 'react';

import type { MenuControlContext as ContextProps } from './types';

const defaultFormControls: ContextProps = {
	load: function (): void {},
	reset: function (): void {},
	close: function (): void {},
	mixedItems: [],
	product: 'unknown',
	subProduct: undefined,
	suggestionConfig: {
		enabled: false,
	},
	isNav4Enabled: true,
	crossAppCreationConfig: {
		enabled: false,
	},
	sections: [],
};

export const MenuControlContext = createContext<ContextProps>(defaultFormControls);

export function useMenuControl() {
	return useContext(MenuControlContext);
}
